module.exports = __webpack_public_path__ + "img/messages_blue.d4d4fb35.svg";